/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */

import React, {useEffect, useRef, useState } from "react";

import { Canvas } from "@react-three/fiber";
import { OrbitControls, Grid, Bounds,useBounds, Points, PointMaterial, Line, Html } from "@react-three/drei";
import * as THREE from "three";

import { Box, CircularProgress } from '@mui/material/';

import Pjdb1ToolTip from "../../../components/inputs/Pjdb1ToolTip";
import {FormTrajectoryResultLinkType} from "../types/trajectoryForm";

import {generateColors, hslToRgb, ColorHsl } from "../../../utils/colorUtil";

interface TrajectoryPointType {linkKey:number; positions: Float32Array; colors: Float32Array};
type ArmPointType = { linkKey:number; linkName:string; point:[number, number, number]; color:ColorHsl };

// リンク上に表示するツールチップ
function Tooltip( { armPoint } : { armPoint:ArmPointType }) {
  const [hovered, setHovered] = useState(false);

  // const linkColor = `hsl(${armPoint.color.hue} ${armPoint.color.saturation}% ${armPoint.color.lightness}%)`;
  const linkColor = hslToRgb(armPoint.color.hue, armPoint.color.saturation, armPoint.color.lightness);

  return (
    <mesh
      position={armPoint.point}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      <sphereGeometry args={[0.01, 16, 16]} />
      <meshStandardMaterial color={hovered ? "#FCCE02" : `rgb(${linkColor.red},${linkColor.green},${linkColor.blue})`} transparent opacity={0.8}/>
      {hovered && (
        <Html position={[0, 0.1, 0]} center>
          <div
            style={{
              background: `rgba(${linkColor.red},${linkColor.green},${linkColor.blue},0.6)`,
              color: "#FFFFFF",
              padding: "5px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              fontWeight: "bold",
              userSelect: "none"
            }}
          >
            {armPoint.linkName}<br/>
            {/* pointオブジェクトはThree.jsの座標系に合わして入れ替えられているので、tooltipはcsv内容の順番に戻す */}
            <small>{`(${armPoint.point[2]},${armPoint.point[0]},${armPoint.point[1]})`}</small>
          </div>
        </Html>
      )}
    </mesh>
  );
}

// 点群とアームの表示
interface TrajectoryPointsProps {
  points:TrajectoryPointType[];
  armPoints:ArmPointType[];
  onLoadPoints?: (pointsGroup: THREE.Group) => void;
}
function TrajectoryPoints(props: TrajectoryPointsProps) {
  const modelRef = useRef<THREE.Group>(new THREE.Group());
  const bounds = useBounds();

  const adjustModel =()=>{
    if(modelRef.current.children.length > 0){
      const box = new THREE.Box3().setFromObject(modelRef.current);
      const size = new THREE.Vector3();
      box.getSize(size);
      const center = new THREE.Vector3();
      box.getCenter(center);

      // modelを中心にずらす
      modelRef.current.position.set(center.x * -1, center.y * -1, center.z * -1);

      bounds.refresh().clip().fit();

      if(props.onLoadPoints){
        props.onLoadPoints(modelRef.current);
      }
    }
  }

  useEffect(()=>{

    adjustModel();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <group ref={modelRef}>
      {/* 点群 */}
      {props.points.map(link =>(
        <Points key={link.linkKey} positions={link.positions} colors={link.colors} stride={3}>
          <PointMaterial
            transparent={true}
            opacity={0.8}
            size={0.015}
            depthWrite={true}
            depthTest={false}
            blending={THREE.NormalBlending}
            vertexColors
          />
        </Points>
      ))}

      {/* アーム */}
      {props.armPoints.length>0 &&
        <Line points={props.armPoints.map(armPoint=>armPoint.point)} color="#222222" lineWidth={12} transparent opacity={0.5}/>
      }
      {props.armPoints.map((point) => (
        <Tooltip key={point.linkKey} armPoint={point} />
      ))}
    </group>
  );

}



interface Props {
  trajectoryObj:number[][][];
  dispLinks: FormTrajectoryResultLinkType[];
  dispPos: number|null;
}
const areEqual = (prevProps: Props, nextProps: Props) => {
  if(prevProps.dispPos !== nextProps.dispPos) return false;
  if(JSON.stringify(prevProps.dispLinks) !== JSON.stringify(nextProps.dispLinks)) return false;
  if(JSON.stringify(prevProps.trajectoryObj) !== JSON.stringify(nextProps.trajectoryObj)) return false;
  return true;
}

let linkKeyIdx = 0;

/**
 * 軌道生成結果の3Dビュー
 * @author TAW j.sano
 * @param props
 * @returns
 */
export default React.memo((props: Props) => {
  const [isOnLoad, setIsOnLoad] = useState(false);

  const [points, setPoints] = useState<TrajectoryPointType[]>([]);
  const [armPoints, setArmPoints] = useState<ArmPointType[]>([]);

  const axesRef = useRef<THREE.AxesHelper>(null);
  const gridRef1 = useRef<THREE.Mesh>(null);
  const [gridArgs1, setGridArgs1] = useState<[number, number]>([2, 2]);
  const gridRef2 = useRef<THREE.Mesh>(null);
  const [gridArgs2, setGridArgs2] = useState<[number, number]>([2, 2]);
  const gridRef3 = useRef<THREE.Mesh>(null);
  const [gridArgs3, setGridArgs3] = useState<[number, number]>([2, 2]);

  let baseColors:ColorHsl[] = [];

  const generatePoints = () => {
    const linkPoints:TrajectoryPointType[] = [];

    baseColors = generateColors(props.trajectoryObj.length); // ベースの色作成

    props.trajectoryObj.forEach((link, linkNum)=>{
      if(props.dispLinks[linkNum].disp){

        const tmpPoints:{position:number[],color:number[]}[] = [];
        const linkColor = baseColors[linkNum];
        const upLightness = (60 - linkColor.lightness) / props.trajectoryObj[0].length; // 明度の上げ幅(最大70%に向けてstep数で割る)

        link.forEach((point, pointPos)=>{

          if(props.dispPos===null || props.dispPos >= pointPos){
            const tmpRgb = hslToRgb(linkColor.hue, linkColor.saturation, linkColor.lightness + upLightness * pointPos);
            tmpPoints.push({
              position: point,
              color: [tmpRgb.red/255, tmpRgb.green/255, tmpRgb.blue/255],
            });
          }

        });

        linkKeyIdx += 1;
        linkPoints.push({
          linkKey: linkKeyIdx,
          positions: new Float32Array(tmpPoints.flatMap(p => p.position)),
          colors: new Float32Array(tmpPoints.flatMap(p => p.color)),
        });
      }
    })
    return linkPoints;
  }
  const generateArmPoints = () => {
    const tmpArmPoints:ArmPointType[]=[];
    let dispStep = 0;
    if(props.dispPos!==null){
      dispStep = props.dispPos;
    }else if(props.trajectoryObj.length > 0){
      dispStep = props.trajectoryObj[0].length -1;
    }

    props.trajectoryObj.forEach((link,idx)=>{
      linkKeyIdx += 1;
      tmpArmPoints.push({
        linkKey: linkKeyIdx,
        linkName: `j${idx+1}`,
        point: link[dispStep] as [number, number, number],
        color: baseColors[idx]
      });
    });

    return tmpArmPoints;
  }

  useEffect(()=>{

    setPoints(generatePoints());
    setArmPoints(generateArmPoints());

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[props.trajectoryObj, props.dispLinks, props.dispPos]);


  const onLoadPoints = (pointsGroup: THREE.Group)=>{
    console.log("onLoadPoints",pointsGroup);
    const box = new THREE.Box3().setFromObject(pointsGroup);
    const size = new THREE.Vector3();
    box.getSize(size);

    // モデルを中心にずらした分の基点のポジション
    /*
    const basePoint:THREE.Vector3 = new THREE.Vector3(
      size.x / 2 * -1,
      size.y / 2 * -1,
      size.z / 2 * -1
    );
    */
    const basePoint:THREE.Vector3 = new THREE.Vector3(
      pointsGroup.position.x,
      pointsGroup.position.y,
      pointsGroup.position.z
    );

    const max2D = Math.ceil(Math.max(size.x /2 , size.z /2 ));
    const maxY = Math.ceil(size.y) > max2D ? Math.ceil(size.y) : max2D;

    if(axesRef.current){
      axesRef.current.scale.set(max2D, maxY * 2, max2D);
      axesRef.current.position.set(basePoint.x, basePoint.y, basePoint.z);
    }

    // 床、壁
    if(gridRef1.current){
      // gridRef1.current.position.set(0, basePoint.y, 0);
      gridRef1.current.position.set(basePoint.x, basePoint.y, basePoint.z);
      setGridArgs1([max2D*2, max2D*2]);
    }
    if(gridRef2.current){
      // gridRef2.current.position.set(0, basePoint.y + max2D, max2D * -1);
      gridRef2.current.position.set(basePoint.x, basePoint.y + max2D, basePoint.z + max2D * -1);
      setGridArgs2([max2D*2, max2D*2]);
    }
    if(gridRef3.current){
      // gridRef3.current.position.set(max2D * -1, basePoint.y + max2D, 0);
      gridRef3.current.position.set(basePoint.x + max2D * -1, basePoint.y + max2D, basePoint.z);
      setGridArgs3([max2D*2, max2D*2]);
    }

    setIsOnLoad(true);
  }

  return (
    <>
      { !isOnLoad &&
        <Box display="flex" justifyContent="center" alignItems="center"
          width="100%" height="100%" sx={{position:"absolute",top:0,left:0,backgroundColor:"rgba(255, 255, 255, .6)"}}>
          <CircularProgress size="25px" sx={{color:"gray"}} />
        </Box>
      }
      <span style={{ visibility: isOnLoad ? "visible" : "hidden" }}>
        <Canvas shadows={{ type: 2 }} camera={{ position: [-1, 0.7, 1], fov: 75}} >

          {/* 環境設定 */}
          <ambientLight intensity={0.5} />
          <directionalLight position={[5, 5, 5]} castShadow />

          {/* Helper */}
          <Grid ref={gridRef1} args={gridArgs1} position={[0, 0, 0]} sectionSize={1} sectionThickness={0} cellSize={0.1} cellThickness={0.8} cellColor="rgb(224, 224, 224)" />
          <Grid ref={gridRef2} args={gridArgs2} position={[0, 2.5, -2.5]} sectionSize={1} sectionThickness={0} cellSize={0.1} cellThickness={0.8} cellColor="rgb(224, 224, 224)" rotation={[Math.PI / 2, 0, 0]} />
          <Grid ref={gridRef3} args={gridArgs3} position={[-2.5, 2.5, 0]} sectionSize={1} sectionThickness={0} cellSize={0.1} cellThickness={0.8} cellColor="rgb(224, 224, 224)" rotation={[Math.PI / 2, 0, Math.PI / 2 * -1]} />
          <axesHelper ref={axesRef} scale={[5, 5, 5]} position={[0, 0, 0]} />


          <Bounds observe>
            {/* 点群とアーム表示 */}
            <TrajectoryPoints points={points} armPoints={armPoints} onLoadPoints={onLoadPoints} />

          </Bounds>

          {/* 操作用カメラコントロール */}
          <OrbitControls enableZoom={true} />

        </Canvas>
        <Box display="flex" sx={{position:"absolute",top:"-14px",right:"3px"}}>
          <Pjdb1ToolTip toolTip={
            <span>
              スクロール：拡大/縮小<br />
              (左クリック)ドラッグ：回転<br />
              (右クリック)ドラッグ：移動
            </span>
          } />
        </Box>
      </span>
    </>
  );
}, areEqual);
